import Column from '@components/Column';
import Text from '@components/Text';
import { OrderReceiptResponse } from '@models/order';
import { Fragment } from 'react';

import styles from './styles.module.scss';
import ReceiptDivider from '../ReceiptDivider';

interface Props {
    receipt: OrderReceiptResponse;
}

function Items({ receipt }:Props) {
  const { order } = receipt;
  const { orderLines } = order;
  return (
        <Column as='section' fullWidth>
            <div className={styles.grid}>
                <Text>메뉴</Text>
                <Text>수량</Text>
                <Text>금액</Text>
            </div>
            <ReceiptDivider/>
            <Column spacing={20} fullWidth>
                {orderLines.map((orderLine, i) => {
                  const {
                    itemName, itemPrice, qty, orderOptions,
                  } = orderLine;
                  return (
                        <div className={styles.grid}
                             key={`orderLine ${i}`} >
                            <Text size='lg' fontWeight='bold'>{itemName}</Text>
                            <Text size='lg' fontWeight='bold'>{qty.toLocaleString()}</Text>
                            <Text size='lg' fontWeight='bold'>{itemPrice.toLocaleString()}</Text>
                            {orderOptions?.sort((a, b) => a.optionName.localeCompare(b.optionName))
                              .map((orderOption, j) => {
                                const { optionName, optionPrice, qty: optionQty } = orderOption;
                                return (
                                    <Fragment key={`orderOption ${i}-${j}`}>
                                        <Text>- {optionName}</Text>
                                        <Text>{optionQty.toLocaleString()}</Text>
                                        <Text>{optionPrice.toLocaleString()}</Text>
                                    </Fragment>
                                );
                              })}
                        </div>
                  );
                })}
            </Column>
            <ReceiptDivider/>
        </Column>
  );
}

export default Items;
